/*
	Только ES5: не использовать =>, const и т.п.
*/

angular.module('cian.serp')
	.controller('SerpListCtrl', [
		"$scope",
		"$window",
		"SerpListService",
		"FilterService",
		"ScrollService",
		"StateService",
		"ShowOffersService",
		"SerpViewMode",
		function($scope, $window, SerpListService, FilterService, ScrollService, StateService, ShowOffersService, SerpViewMode) {
		var ctrl = {};

		$scope.$watch(function() {
			return SerpListService.offers;
		}, function(newValue) {
			if (newValue) {
				ctrl.offersHtml = newValue.html;
			}
		});

		$scope.showOffers = function ($event, page) {
			$event.preventDefault();

      ShowOffersService.updateOffers(page);
		};

		ctrl.isEmpty = function () {
			return !SerpListService.getOffersCount();
		};

		ctrl.SerpListService = SerpListService;

		ctrl.subscribe = {
			email: StateService.email,
			get dealType() {
				return FilterService.dealType;
			},
			get searchTitle() {
				return SerpListService.getSearchTitle();
			},
			get url() {
				return SerpListService.getFullUrl();
			},
		};

		ctrl.sendFeedbackGTMEvent = function () {
			ca('event', {
				name: 'oldevent',
				category: 'Listing',
				action: 'to_survey',
				label: 'about_new_design'
			});
		};

		ctrl.initObjects = function () {
			// Подключаем контролы на табличной (избранное, карта и т.п.)
			if (SerpViewMode.isTable) $window.initAllObjects();
		};

		return ctrl;
	}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.list.js
// module id = 490
// module chunks = 0